import { render, staticRenderFns } from "./IconOutgoing.vue?vue&type=template&id=0fc6727d&"
import script from "./IconOutgoing.vue?vue&type=script&lang=ts&"
export * from "./IconOutgoing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports